var _rect, _path, _circle, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.1875,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#FFF9EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1667 39.5311C30.5857 39.4358 31.8333 41.1873 31.8333 41.1873L35.6234 41.1873C36.1156 41.1874 36.4719 41.1874 37.4042 41.1873H40.1667C40.1667 41.1873 41.4143 39.4358 41.8333 39.5311C46.3368 40.5568 51 43.5161 51 46.6622V51.1873H21V46.6622C21 43.5161 25.6632 40.5568 30.1667 39.5311ZM42.6667 44.5206V42.8539H44.3333V44.5206H46V46.1873H44.3333V47.8539H42.6667V46.1873H41V44.5206H42.6667Z",
    fill: "#F687B3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.0001,
    cy: 29.5208,
    r: 8.33333,
    fill: "#F687B3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.6667,
    y: 42.8535,
    width: 1.66667,
    height: 5,
    fill: "#B83280"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 44.5215,
    width: 1.66667,
    height: 5,
    transform: "rotate(90 46 44.5215)",
    fill: "#B83280"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrs);
export default __webpack_public_path__ + "static/media/TRS.1c9aa73647d85b7f9c92262c6b79ac7e.svg";
export { ForwardRef as ReactComponent };